require('../../modules/web.url-search-params');

module.exports = require('../../internals/path').URLSearchParams;
